import axios from 'axios';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { initialize } from 'redux-form';

const API = `${consts.API_URL}/veiculo`;

export const VEICULO_MODO_TELA = 'VEICULO_MODO_TELA';
export const VEICULO_SET_AGUARDANDO = 'VEICULO_SET_AGUARDANDO';
export const VEICULO_LISTADO = 'VEICULO_LISTADO';

export function setModoTela(modo, registro = {}) {
    return {
        type: VEICULO_MODO_TELA,
        payload: {
            modo,
            registro
        }
    };
}

export function setAguardando(aguardando) {
    return {
        type: VEICULO_SET_AGUARDANDO,
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('veiculoForm', registro)
    ];
}

export function getLista() {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            const resp = await axios.get(API);

            dispatch({
                type: VEICULO_LISTADO,
                payload: resp
            });

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function salvar(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            const request = registro.id
                ? axios.put(API, registro)
                : axios.post(API, registro);

            await request;

            setSuccess('Operação realizada com sucesso.');

            dispatch(getLista());
            dispatch(setModoTela('lista'));

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function excluir(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            await axios.delete(API, {
                params: {
                    id: registro.id
                }
            });

            setSuccess('Operação realizada com sucesso.');

            dispatch(getLista());
            dispatch(setModoTela('lista'));

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}